import(/* webpackMode: "eager" */ "/app/app/owner-portal/page.tsx");
